<template>
    <transition name="fade">
        <div v-show="(!!monologue || wedding) && !hide" class="monologue-wrap">
<!--        <div class="monologue-wrap">-->
            <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/background_monologue.png" />
            <v-layout class="text" justify-center align-center>
                <span v-if="monologue" v-html="monologue"></span>
                <span v-else-if="wedding">
                    <img src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/icon_get_married.png" />
                </span>
            </v-layout>
        </div>
    </transition>
</template>

<script>
    export default {
        data() {
            return {
                hide: false,
                st: null,
                wedding: false,
            }
        },
        computed: {
            sequence() {
                return this.$userData.sequence
            },

            monologue() {

                if (!this.$gameData.questions) return ''

                let monologue = ''
                this.$gameData.questions.forEach(question => {
                    if (question.age === this.$userData.age && question.sequence === this.sequence) {
                        if (question.monologue) {
                            monologue = (question.monologue || '우와 나도\n대학생!!').replace(/\n/g, '<br />')
                        }
                    }
                })
                // monologue = '우와 나도\n대학생!!'.replace(/\n/g, '<br />')

                return monologue
            }
        },

        watch: {
            monologue(val) {
                if (val) {

                    this.hide = false

                    if (this.st) {
                        clearTimeout(this.st)
                    }

                    this.st = setTimeout(_ => {
                        this.hide = true
                        this.wedding = false
                        this.st = null
                    }, 3000)
                }
            }
        },

        beforeDestroy() {
            this.$eventBus.$off('GET_MARRIED')
        },

        mounted() {
            this.$eventBus.$on('GET_MARRIED', _ => {

                this.hide = false
                this.wedding = true

                if (this.st) {
                    clearTimeout(this.st)
                }

                this.st = setTimeout(_ => {
                    this.hide = true
                    this.wedding = false
                    this.st = null
                }, 2000)
            })
        },
    }
</script>

<style lang="scss" scoped>
    .monologue-wrap {
        position: absolute;
        bottom: 180px;
        left: 160px;

        .text {
            position: absolute;
            left: 10px;
            top: 7px;
            right: 5px;
            bottom: 30px;
            word-break: keep-all;
            font-family: GmarketSans, sans-serif;
            font-weight: 600;
            font-size: 13px;
            color: #292727;
            line-height: 1.23;
        }
    }

</style>
